import React, { useEffect, useState } from 'react'
import { Link } from '@reach/router'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

const PROMO_END_TIME = new Date('2026-05-12T09:00:00-05:00').getTime()
const PROMO_ID = 'spring-sale-2026'
const PROMO_DISMISSED_KEY = `promo-banner-dismissed:${PROMO_ID}`

const hasLocalStorage = () => typeof window !== 'undefined' && window.localStorage

const getRemainingTime = () => {
  const total = Math.max(PROMO_END_TIME - Date.now(), 0)
  const days = Math.floor(total / (1000 * 60 * 60 * 24))
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
  const minutes = Math.floor((total / (1000 * 60)) % 60)
  const seconds = Math.floor((total / 1000) % 60)

  return { days, hours, minutes, seconds, ended: total === 0 }
}

const padTime = value => String(value).padStart(2, '0')

export const PromoBanner = () => {
  const [remaining, setRemaining] = useState(getRemainingTime)
  const [dismissed, setDismissed] = useState(() => {
    if (!hasLocalStorage()) {
      return false
    }
    return window.localStorage.getItem(PROMO_DISMISSED_KEY) === 'true'
  })

  useEffect(() => {
    const timer = setInterval(() => {
      setRemaining(getRemainingTime())
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  const closeBanner = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (hasLocalStorage()) {
      window.localStorage.setItem(PROMO_DISMISSED_KEY, 'true')
    }
    setDismissed(true)
  }

  if (dismissed) {
    return null
  }

  return <div style={{
    position: 'relative',
    width: '100%',
    background: '#ff651a',
    color: '#fff',
    textAlign: 'center',
    fontSize: 16,
    lineHeight: '24px',
    padding: '8px 12px',
    boxSizing: 'border-box',
    zIndex: 1400
  }}>
    <Link to="/promo" style={{
      color: '#fff',
      textDecoration: 'none',
      display: 'inline-flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 10
    }}>
      <span>Spring Sale: Up to 50% Off</span>
      {!remaining.ended && <strong>
        Ends in {remaining.days}d {padTime(remaining.hours)}h {padTime(remaining.minutes)}m {padTime(remaining.seconds)}s
      </strong>}
      <span style={{textDecoration: 'underline'}}>Shop now</span>
    </Link>
    <IconButton
      aria-label="Close promotion banner"
      size="small"
      onClick={closeBanner}
      style={{
        position: 'absolute',
        right: 8,
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#fff'
      }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </div>
}
